import React from 'react';
import TextLink from '@solar/common/Link/TextLink';
import { CollapsibleContainer2 as CollapsibleContainer } from '@components/common/CollapsibleContainer/CollapsibleContainer';

interface Props {
  title: string;
  initiallyExpanded?: boolean;
  links: {
    text: string;
    href: string;
  }[];
}

export default function SrpSeoSection({ links, title, initiallyExpanded = true }: Props) {
  return (
    <div className="my-spacing-md desktop:my-spacing-sm">
      <CollapsibleContainer
        title={title}
        initiallyExpanded={initiallyExpanded}
        noBorder
        iconSize={16}
      >
        <div className="mt-spacing-xl grid grid-cols-2 gap-x-spacing-md gap-y-spacing-lg whitespace-nowrap overflow-ellipsis desktop:grid-cols-4">
          {links.map((link) => (
            <TextLink
              href={link.href}
              key={link.href}
              title={link.text}
              className="text-sm truncate justify-self-start"
              asChild
            >
              <a>{link.text}</a>
            </TextLink>
          ))}
        </div>
      </CollapsibleContainer>
    </div>
  );
}
